<div class={"flex w-full flex-shrink-0 flex-col items-center justify-center"}>
    <slot />
</div>
